import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from '../../../configuration/colors'

const ButtonElement = styled.button`
  display: inline-block;
  width: ${(props) => props.width || 'auto'};
  padding: 0 10px;
  height: 40px;
  color: ${colors.charcoal4};
  background: ${(props) => props.buttonColor};
  line-height: 40px;
  text-align: center;
  border: 1px solid ${(props) => props.borderColor};
  border-radius: 20px;
  cursor:  ${(props) => props.isDisabled ? 'not-allowed' : 'pointer'};
  font-size: 16px;
  font-weight: 500;
  text-transform: capitalize;
  transition: color 0.4s, background-color 0.4s, opacity 0.4s, border 0.4s;
  outline: none;
  &:hover {
    color:  ${(props) => props.hoverColor};
    background: ${(props) => props.hoverBackground};
    border: 1px solid ${(props) => props.hoverBackground};
  }
  &:disabled {
    background: ${colors.ash};
    cursor: not-allowed;
    border: 1px solid ${colors.ash}
    color: ${colors.white}
  }
  ${(props) => props.small && `
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
    padding: 0 22px;
    font-size: 14px;
  `}
`

export const Button = ({
  handleClick,
  title,
  width,
  buttonColor,
  borderColor,
  hoverBackground,
  hoverColor,
  couldSaveData,
  shouldShowTooltipAndDisableButton,
  small,
  isMutating
}) => {
  return (
    <div>
      <ButtonElement
        width={width}
        onClick={handleClick}
        buttonColor={buttonColor}
        borderColor={borderColor}
        hoverBackground={hoverBackground}
        hoverColor={hoverColor}
        disabled={shouldShowTooltipAndDisableButton && !couldSaveData || isMutating}
        small={small}
      >
        {title}
      </ButtonElement>
    </div>

  )
}

Button.propTypes = {
  handleClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  buttonColor: PropTypes.string.isRequired,
  borderColor: PropTypes.string.isRequired,
  hoverBackground: PropTypes.string.isRequired,
  hoverColor: PropTypes.string.isRequired,
  isMutating: PropTypes.bool,
  shouldShowTooltip: PropTypes.bool,
  couldSaveData: PropTypes.bool,
  small: PropTypes.bool
}

export default Button



// WEBPACK FOOTER //
// ./src/components/mini/Buttons/Button.js